import { render } from "./CryptocurView.vue?vue&type=template&id=19c25392&scoped=true&ts=true"
import script from "./CryptocurView.vue?vue&type=script&lang=ts"
export * from "./CryptocurView.vue?vue&type=script&lang=ts"

import "./CryptocurView.vue?vue&type=style&index=0&id=19c25392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c25392"]])

export default __exports__